export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10295.c5b61d82.jpg";